"use client";

import { BrowserPushFallbackRecovery } from "@/components/notifications/BrowserPushFallbackRecovery";
import { BrowserPushInstallRecovery } from "@/components/notifications/BrowserPushInstallRecovery";
import { useWebPushController } from "@/hooks/use-web-push-controller";

export function BrowserPushRecoveryActions({
  alerts,
  controller,
}: {
  alerts: boolean;
  controller: ReturnType<typeof useWebPushController>;
}) {
  if (controller.status === "install_required") {
    return <BrowserPushInstallRecovery alerts={alerts} controller={controller} />;
  }

  const isUnrecoverableError = controller.status === "error" && !controller.canEnable;
  const isFallbackState = ["denied", "unsupported", "unavailable"].includes(controller.status);
  if (!isFallbackState && !isUnrecoverableError) return null;

  return <BrowserPushFallbackRecovery alerts={alerts} controller={controller} />;
}
